/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const fastingExperience = useStore((state) => state.fastingExperience);
  const setFastingExperience = useStore((state) => state.setFastingExperience);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.fastingExperience.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={fastingExperience}
          onChange={(value) => {
            setFastingExperience(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'fasting-experience',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'regularly'}>
            <span>⏰</span> {t('onboarding.fastingExperience.options.regularly')}
          </Option>
          <Option value={'fewTimes'}>
            <span>🧃</span> {t('onboarding.fastingExperience.options.fewTimes')}
          </Option>
          <Option value={'neverTried'}>
            <span>🚫</span> {t('onboarding.fastingExperience.options.neverTried')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
